import { Link } from "react-router";
import { RouteFactory } from "@app/routePaths";
import logoBudget2026 from "@assets/logo-budget-2026.png";
import { cn } from "@util/helpers";

type SGBudget2026BannerProps = {
  /** This is the classname of the component. */
  className?: string;
};

/**
 * The SGBudget2026Banner component, which displays a banner for the Singapore Budget 2026.
 * @figma https://www.figma.com/design/rjN90rsrisQ4kMbpzr55Y3/BUDGET-2026--WEB---APP-?node-id=8061-23438&t=ENcHCChp5MJlk48O-4
 */
const SGBudget2026Banner = ({
  className,
}: SGBudget2026BannerProps): React.ReactElement => {
  return (
    <div
      data-testid="sg-budget-2026-banner-component"
      className={cn(
        "relative flex w-full flex-wrap items-center justify-center gap-2 rounded-md bg-red-25 px-2 py-3 xs:gap-6",
        className
      )}
    >
      <img
        src={logoBudget2026}
        alt="Singapore Budget 2026"
        width={109}
        height={39}
      />

      <div className="relative after:absolute after:-left-3 after:top-0 after:hidden after:h-full after:w-px after:bg-gray-175 xs:after:block">
        <h3 className="font-poppins text-2xs font-semibold leading-6 tracking-2% text-gray-695">
          Singapore Budget 2026
        </h3>

        <p className="font-poppins text-2xs font-normal leading-5 text-gray-695">
          Read our coverage
        </p>
      </div>

      <Link
        to={`${RouteFactory.keywordsBudget2026}?ref=singapore-budget-2026-banner`}
        target="_blank"
        className="absolute inset-0"
      />
    </div>
  );
};

export default SGBudget2026Banner;
